module.exports = __webpack_public_path__ + "ef4c18fec893443d3ae0cccacc8fef57.svg";